import { Log } from "../utils";
import { ERR_FAILED, newError } from "../utils/error";
import { isNullOrEmpty } from "../utils/string";
import { ItemUpdateFlags } from "./BaseItem";
import { ViewItem } from "./ViewItem";
import { ArticleItem } from "./ArticleItem";
export class ViewArticleItem extends ViewItem {
    get isOfmlArticle() {
        return (true);
    }
    async setQuantity(pQuantity) {
        const tBasketItem = this._getConfigArticleItem(false);
        await tBasketItem.setQuantity(pQuantity);
        const tMainBasketArticle = tBasketItem.getMainArticle();
        if (this.mManager.viewConfig.mergeMode === "SubArticles" &&
            tMainBasketArticle.item.subArticleIds != null && tMainBasketArticle.item.subArticleIds.length > 0) {
            //TODO: improve this
            //force full update of view
            await this.mManager._updateViewItem(tMainBasketArticle, ItemUpdateFlags.Item);
        }
        return (this.mManager.update());
    }
    /**
     * Searches for the main view article item.
     */
    findMainArticle() {
        const tBasketItem = this.getFirstBasketItem();
        if (!(tBasketItem instanceof ArticleItem) || !tBasketItem.isSubArticle())
            return (null);
        const tViewItem = this.mManager.getItemByBasketId(tBasketItem.id);
        if (tViewItem instanceof ViewArticleItem)
            return (tViewItem);
        else
            return (null);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _getConfigArticleItem(pAllowMerged) {
        if (this.mItem.basketItemIds == null || this.mItem.basketItemIds.length === 0)
            throw newError(ERR_FAILED, "No basket item found.");
        if (this.mItem.basketItemIds.length > 1 && !pAllowMerged && this.mManager.viewConfig.mergeMode !== "Compact")
            throw newError(ERR_FAILED, "Not supported for merged items.");
        const tItem = this.getFirstBasketItem();
        if (tItem instanceof ArticleItem) {
            return (tItem);
        }
        else {
            throw newError(ERR_FAILED, "Basket item is not an article.");
        }
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    async generateImageUrl() {
        this.mImageUrl = null;
        let tConfigItem = null;
        let tCamSetup = null;
        let tPreferStoredImage = true;
        try {
            tConfigItem = this._getConfigArticleItem(true);
        }
        catch (pError) {
            Log.error("Failed to get config item.", pError);
        }
        if (tConfigItem != null) {
            tCamSetup = tConfigItem.getCameraSetup();
            tPreferStoredImage = tConfigItem._preferStoredImage();
        }
        //try to get stored image first
        if (tCamSetup == null || tPreferStoredImage) {
            const tStoredImage = await this.getStoredImage();
            if (tStoredImage != null) {
                if (tConfigItem != null && tCamSetup == null) {
                    await tConfigItem.setCameraSetup(this.getCameraSetupFromImage(tStoredImage), false);
                }
                this.mImageUrl = tStoredImage.url;
                return;
            }
        }
        //generate new image on server
        const tGeneratedImage = await this.getGeneratedImage(tCamSetup);
        if (!isNullOrEmpty(tGeneratedImage)) {
            this.mImageUrl = tGeneratedImage;
            return;
        }
        //use stored image as fallback if not already requested
        if (!tPreferStoredImage) {
            const tStoredImage = await this.getStoredImage();
            if (tStoredImage != null) {
                this.mImageUrl = tStoredImage.url;
                return;
            }
        }
        //use catalog image as fallback
        const tCatalogImage = await this.getCatalogImage();
        if (!isNullOrEmpty(tCatalogImage)) {
            this.mImageUrl = tCatalogImage;
        }
    }
}
